import React from "react";
import { useViewport } from "../../../../../styles/media";
import { SlotStack, SlotStackItem } from "../../../../Stacks/SlotStack/SlotStack";
import { Stack } from "../../../../Stacks/Stack/Stack";
import { StopPropagation } from "../../../../StopPropagation/StopPropagation";
import { Text } from "../../../../Text/Text";
import { Toggle, ToggleProps } from "../../../../Toggle/Toggle";
import { enterKeyStopPropagation } from "../props";

export interface DrawerHeaderToggleProps extends ToggleProps {
    /**
     * Which side the toggle should be positioned
     */
    readonly togglePosition?: "start" | "end";
}

export const DrawerHeaderToggle: React.FC<DrawerHeaderToggleProps> = ({
    label,
    togglePosition = "start",
    ...otherProps
}) => {
    const viewport = useViewport();
    const onCollapsingViewport = (viewport === "s" || viewport === "m" || viewport === "l");

    let toggleProps = { ...otherProps };

    if (onCollapsingViewport) {
        toggleProps = {
            ...otherProps,
            offText: undefined,
            onText: undefined
        };
    }
    return (
        <SlotStack totalSlots={5} reversed={togglePosition === "end"} verticalAlign="center">
            <SlotStackItem slots={2}>
                <Stack verticalAlign={"center"} horizontalAlign="end" padding="12px 0 0 0">
                    <StopPropagation keycodes={[enterKeyStopPropagation]}>
                        <Toggle {...toggleProps} />
                    </StopPropagation>
                </Stack>
            </SlotStackItem>
            <SlotStackItem slots={3} >
                {!onCollapsingViewport && (
                    <Text variant="bodySecondaryText" block={true} nowrap={true}>
                        {label}
                    </Text>
                )}
            </SlotStackItem>
        </SlotStack>
    );
};
